<template>
  <div class="CompanyHeaderWrap">
    <div class="inner_center">
      <h1>潮国创意商用VIP授权</h1>

      <div class="list-box">
        <div class="list-item">
          <i class="iconfont icon-chaxun1"></i>
          <div class="bar">
            VIP专享内容
          </div>
        </div>
        <div class="list-item">
          <i class="iconfont icon-shang"></i>
          <div class="bar">
            子账号赋权
          </div>
        </div>
        <div class="list-item">
          <i class="iconfont icon-gongxiang">

<!--            <i class="icon_float">即将上线</i>-->
          </i>
          <div class="bar">
            团队共享收藏夹
          </div>


        </div>
        <div class="list-item">
          <i class="iconfont icon-xiazai"></i>
          <div class="bar">
            在线下载授权书
          </div>
        </div>
        <div class="list-item">
          <i class="iconfont icon-dingzhi21">
            <i class="icon_float">限时海量</i>
          </i>
          <div class="bar">
            免费定制服务 <a href="https://chaopx.com/fans/demand-pool" target="_blank">去体验 ></a>
          </div>

        </div>
        <div class="list-item">
          <i class="iconfont icon-avataryouli"></i>
          <div class="bar">
<!--            每日签到有礼 <a href="https://chaopx.com/fans-club" target="_blank">去体验 ></a>-->
<!--            每日签到有礼 <a @click.prevent="wait">去体验 ></a>-->
            营销日历自定义日程 <a :href="CALENDAR" target="_blank" >去体验 ></a>
          </div>
        </div>
<!--        <div class="list-item">
          <i class="iconfont icon-avatarlaxing"></i>
          <div class="bar">
&lt;!&ndash;            拉新返利 <a href="https://chaopx.com/fans-club" target="_blank">去体验 ></a>&ndash;&gt;
            拉新返利 <a @click.prevent="wait">去体验 ></a>
          </div>
        </div>-->
      </div>
      <!--      <div class="identify-box">
              <div class="identify-item">
                <i class="icon_shangyong"/>
                <span>企业商用授权</span>
              </div>
              <div class="identify-item">
                <i class="icon_zhengshu"/>
                <span>证书在线获取</span>
              </div>
              <div class="identify-item">
                <i class="icon_banquan"/>
                <span>有版权敢商用</span>
              </div>
            </div>
            <div class="buy _pointer" @click="buy(COMPANY_All_PURPOSE)">立即开通</div>-->

      <div class="watch-scope" @click="showScope">查看详细授权范围 <i class="iconfont icon-a-arrowright3"/></div>
    </div>
  </div>
</template>

<script>

import {COMPANY_All_PURPOSE, COMPANY_ONLINE} from "@/constant/VIP_COMPANY";
import {CALENDAR} from "@/constant/_Public/Path";

export default {
  name: "CompanyHeaderWrap",
  data() {
    return {
      COMPANY_All_PURPOSE,
      CALENDAR
    }
  },
  methods: {
    buy(vipInfo) {
      this.$emit('buy', vipInfo)
    },
    showScope() {
      this.$emit('showScope')
    },
    wait(){
      this.$myNotify.show('敬请期待')
    }
  }
}
</script>

<style lang="scss" scoped>
.CompanyHeaderWrap {
  width: 100%;
  height: 1054px;
  background: linear-gradient(223deg, #404670 0%, #30385A 20%, #30385A 62%, #393E65 100%);
  position: relative;

  .inner_center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .watch-scope {
    transform: translateX(-50%);
    @include Position(1, 4, 50%, 50px);
    width: 165px;
    height: 36px;
    background: linear-gradient(270deg, rgba(66, 74, 113, 0.17) 0%, rgba(66, 74, 113, 0.6) 55%, rgba(66, 74, 113, 0.17) 100%);
    border-radius: 18px;
    font-size: 12px;
    color: #7D87B9;
    line-height: 16px;
    letter-spacing: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @include ElementHover(rgba(162, 171, 216, 1), linear-gradient(270deg, rgba(66, 74, 113, 0.17) 0%, rgba(66, 74, 113, 0.6) 55%, rgba(66, 74, 113, 0.17) 100%));

    .icon-a-arrowright3 {
      margin-left: 4px;
    }

  }


  h1 {
    font-weight: bold;
    padding: 40px 0 50px;
    font-size: 46px;
    color: #FFD0AC;
    line-height: 61px;
    letter-spacing: 7px;
  }

  .list-box {

    display: flex;

    .list-item {
      color: rgba(241, 213, 178, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-right: 20px;
      position: relative;

      &:last-child {
        margin-right: 0;
      }

      .iconfont {
        display: inline-block;
        font-size: 33px;
        margin-bottom: 9px;
        position: relative;

        .icon_float {
          display: inline-block;
          width: 60px;
          box-sizing: border-box;
          height: 18px;
          @include Position(1, 2, -50px, -9px);
          background: linear-gradient(90deg, #FF619C 0%, #FF8E71 100%);
          box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.15);
          border-radius: 30px 2px 30px 2px;
          font-size: 12px;
          color: #FFFFFF;
          //padding: 0 6px;
          text-align: center;


        }

      }

      .bar {
        //width: 90px;
        height: 24px;
        line-height: 24px;
        background: linear-gradient(270deg, rgba(66, 74, 113, 0) 0%, rgba(66, 74, 113, 0.64) 54%, rgba(66, 74, 113, 0) 100%);
        box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.15);
        padding: 0 9px;

        a {
          margin-left: 2px;
          color: rgba(255, 255, 255, 0.5);
          text-decoration: underline;

          &:hover {
            color: $color-primary;
          }
        }
      }


    }
  }

  .identify-box {
    display: flex;
    justify-content: center;
    width: 494px;
    height: 38px;
    background: linear-gradient(270deg, rgba(66, 74, 113, 0) 0%, rgba(66, 74, 113, 0.64) 54%, rgba(66, 74, 113, 0) 100%);

    .identify-item {
      letter-spacing: 1px;
      font-size: 0;
      display: flex;
      align-items: center;
      margin-right: 48px;

      //font-size: 13px;
      color: #EDCCA7;
      line-height: 18px;

      &:last-child {
        margin-right: 0;
      }

      i {
        margin-right: 8px;

        &.icon_shangyong {
          @include BgImage(18px, 18px, 'introduce/company/icon_shangyong.png');
        }

        &.icon_zhengshu {
          @include BgImage(18px, 18px, 'introduce/company/icon_zhengshu.png');
        }

        &.icon_banquan {
          @include BgImage(18px, 18px, 'introduce/company/icon_banquan.png');
        }
      }

      span {
        font-size: 13px;
      }
    }

  }

  .buy {
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #2E3351;
    margin-top: 32px;
    @include ElementHover('', linear-gradient(51deg, #E8BF97 0%, #F5D9C3 100%));

    width: 240px;
    height: 50px;
    background: linear-gradient(51deg, #F5D9C3 0%, #E8BF97 100%);
    border-radius: 27px;
  }
}
</style>
